import { Helmet } from "react-helmet";
import QuotationBody from "../components/quotation/QuotationBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Quotation() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/get-free-quote"
        />
        <meta
          name="description"
          content="Request a personalized quotation from NTUNA.COM for our services of Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        
        <meta
          property="og:description"
          content="Request a personalized quotation from NTUNA.COM for our services of Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          property="og:title"
          content="NTUNA.COM - Get Your Free Quotation | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM - Get Your Free Quotation | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM - Get Your Free Quotation | Uganda"
        />
        <meta
          name="twitter:description"
          content="Request a personalized quotation from NTUNA.COM for our services of Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM - Get Your Free Quotation</title>
      </Helmet>
      <PageHero
        classes="dark-bg"
        titleClasses="title uppercase ntuna-deep-blue"
        title="Get Free Quote"
      />
      <QuotationBody />
    </>
  );
}
